import { render, staticRenderFns } from "./SalesPeriodIframe.vue?vue&type=template&id=ab7462f8&"
import script from "./SalesPeriodIframe.vue?vue&type=script&lang=ts&"
export * from "./SalesPeriodIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports